import { Button, Modal, ModalBody, ModalContent, ModalFooter } from '@heroui/react';

interface ExitDialogProps {
    open: boolean;
    handleCancelar: () => void;
    handleAceptar: () => void;
    title: string;
    subtitle: string;
}

const ExitDialogComponent = ({ open, handleCancelar, handleAceptar, title, subtitle }: ExitDialogProps) => {

    return (
        <Modal isOpen={open} onClose={handleCancelar}>
            <ModalContent>
                <ModalBody className="p-2">
                    <div className="flex flex-col items-center justify-center">
                        <h6 className="py-4 text-center text-lg font-bold">{title}</h6>
                        <p className="pb-4 text-center text-base text-[#757575]">{subtitle}</p>
                    </div>
                </ModalBody>
                <ModalFooter className="px-8 pb-8 pt-0">
                    <Button color='danger' onPress={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button
                        color="primary"
                        onPress={() => {
                            handleAceptar();
                            handleCancelar();
                        }}
                        autoFocus
                    >
                        Aceptar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ExitDialogComponent;
